<div class="nutritional-assessment">
  <p class="description">{{ 'sr-xray_block_title_more_infos' | translateKey }}</p>
  <div class="nutrients-infography">
    <h4 class="nutrients-infography-title">{{ 'sr-xray_nutrient_bar_definition_title' | translateKey }}</h4>

    <div class="nutrients-infography-details">
      <app-nutrients-bar [id]="'desktop'" [nutrients]="nutrientsMock"></app-nutrients-bar>
      <div>
        <p class="nutrients-infography-definition">
          {{ 'sr-xray_nutrient_bar_definition' | translateKey }}
        </p>

        <div class="nutritional-assessment-link-container">
          <rc-link
            data-qa="vs-nutritional-assessment-step-button-download-faq"
            variant="secondary"
            size="large"
            target="_blank"
            rel="noopener"
            iconname="document-pdf"
            iconposition="left"
            [href]="xrayFAQPdfUrl$ | async"
          >
            {{ 'sr-xray_download-complete-faq' | translateKey }} [PDF]
          </rc-link>
        </div>
      </div>
    </div>
  </div>

  @if ((nutritionalAssessmentLoading$ | async) === false) {
    @if ((nutritionalAssessmentHasError$ | async) === false) {
      <app-nutrients-list
        [nutrients]="macroNutrients$ | async"
        [nutrientType]="NutrientType.MACRONUTRIENTS"
        [nutrientListTitle]="'sr-xray_column_title_macronutrients' | translateKey"
      ></app-nutrients-list>
      <app-nutrients-list
        [nutrients]="otherNutrients$ | async"
        [nutrientType]="NutrientType.OTHER_NUTRIENTS"
        [nutrientListTitle]="'sr-xray_2nd_block_title' | translateKey"
      ></app-nutrients-list>
      <app-nutrients-benefits-list
        [benefits]="benefitClaim$ | async"
        [nutrientListTitle]="'sr-xray_3rd_block_title' | translateKey"
      ></app-nutrients-benefits-list>
    }
  } @else {
    <div class="loader">
      <app-loader [transparent]="true" [withinContent]="true" [size]="rcLoaderSize"></app-loader>
    </div>
  }

  @if (nutritionalAssessmentHasError$ | async) {
    <div class="no-results">
      <app-no-results
        [title]="'sr-xray_error_message_title' | translateKey"
        [description]="'sr-xray_error_message_retry' | translateKey"
        [actionLabel]="'action_retry' | translateKey"
        (actionOutput)="retryGetNutritionalAssessment()"
      ></app-no-results>
    </div>
  }
  <footer class="footer">
    <rc-button
      id="get-recommendation"
      data-qa="vs-nutritional-assessment-step-button-nutritional-recommendation"
      (click)="submitRecommendation()"
    >
      {{ 'rd-title-nutritional-recommendations' | translateKey }}
    </rc-button>
  </footer>
</div>
